import { render, staticRenderFns } from "./OutsourcedGoodsPivotTab.vue?vue&type=template&id=92606ef6&"
import script from "./OutsourcedGoodsPivotTab.vue?vue&type=script&lang=js&"
export * from "./OutsourcedGoodsPivotTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports